
import { calculateMortgageData } from '@/utils/calculator/mortgageCalculator';
import type { MortgageData } from '@/types/calculator';

// Legacy wrapper for components that still call with 3 arguments
export const calculateMortgageDataLegacy = (
  data: MortgageData,
  _calculateFundingFee?: any,
  _autoCalculate?: any
): MortgageData => {
  // Simply call the new single-argument function
  return calculateMortgageData(data);
};

// Re-export the main function for consistency
export { calculateMortgageData };
